export default function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-title">
          <h2>Contact</h2>
          <p>
            Contact <span>us</span>
          </p>
        </div>
        <div className="row mt-2">
          <div className="col-md-6 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-map"></i>
              <h3>Location</h3>
              <p>
                Suite #43, 44, Old Rally Building, Talpur Road, Lalazar, Karachi, 74000, Pakistan
              </p>
            </div>
          </div>
          <div className="col-md-6 mt-4 mt-md-0 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-time"></i>
              <h3>Open Hours</h3>
              <p>Monday - Friday<br/>09:30 AM - 05:30 PM</p>
            </div>
          </div>

          <div className="col-md-6 mt-4 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-envelope"></i>
              <h3>Email</h3>
              <p>support@fundsmi.com</p>
            </div>
          </div>
          <div className="col-md-6 mt-4 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-phone-call"></i>
              <h3>Call</h3>
              <p>(021) 32428911-13<br/>+92300-8223858</p>
            </div>
          </div>

          <div className="col-md-12 mt-4 d-flex align-items-stretch">
            <div className="info-box">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d57927.18120103364!2d66.999527!3d24.848516!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33f28961d8af5%3A0x95f65a26898da3e6!2sFund%20Marketing%20International%20(FMI)!5e0!3m2!1sen!2sus!4v1789558643358!5m2!1sen!2sus"
                allowFullScreen=""
                loading="lazy"
                title='map'
                referrerPolicy="strict-origin-when-cross-origin"
                style={{
                  border: "solid 2px #f9ac3b",
                  width: "100%",
                  height: "350px",
                }}
              ></iframe>
            </div>
          </div>
        </div>

        {/* <form action="forms/contact.php" method="post" className="php-email-form mt-4">
          <div className="form-row">
            <div className="col-md-6 form-group">
              <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
              <div className="validate"></div>
            </div>
            <div className="col-md-6 form-group">
              <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" data-msg="Please enter a valid email" />
              <div className="validate"></div>
            </div>
          </div>
          <div className="form-group">
            <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
            <div className="validate"></div>
          </div>
          <div className="form-group">
            <textarea className="form-control" name="message" rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message"></textarea>
            <div className="validate"></div>
          </div>
          <div className="mb-3">
            <div className="loading">Loading</div>
            <div className="error-message"></div>
            <div className="sent-message">Your message has been sent. Thank you!</div>
          </div>
          <div className="text-center"><button type="submit">Send Message</button></div>
        </form> */}
      </div>
    </section>
  )
}
